__turbopack_context__.v({
  "main": "Home-module__g21JLG__main",
  "tabContainer": "Home-module__g21JLG__tabContainer",
  "tabContent": "Home-module__g21JLG__tabContent",
  "tabSelect": "Home-module__g21JLG__tabSelect",
});
